/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formmessage_Label1Inputs */

const ja_contact_formmessage_label1 = /** @type {(inputs: Contact_Formmessage_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ内容の詳細`)
};

const en_contact_formmessage_label1 = /** @type {(inputs: Contact_Formmessage_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Message`)
};

/**
* | output |
* | --- |
* | "Your Message" |
*
* @param {Contact_Formmessage_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formmessage_label1 = /** @type {((inputs?: Contact_Formmessage_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formmessage_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formmessage_label1(inputs)
	return en_contact_formmessage_label1(inputs)
});
export { contact_formmessage_label1 as "contact_formMessage_label" }